<div *ngIf="loading" class="as-fixed-loader">
  <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
  <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
    {{ 'GENERAL.adding' | translate }}...
  </mat-label>
</div>
<mat-card class="as-product-card">
  <div class="as-heart-circle" *ngIf="!loadingFavourites; else loadFav">
    <mat-icon
      (click)="openSureDeleteProductFromList()"
      *ngIf="product.showHeart"
      class="as-pointer"
      svgIcon="ic-on"
    >
    </mat-icon>
    <mat-icon
      (click)="addProductToFavouriteList()"
      *ngIf="!product.showHeart"
      class="as-pointer"
      svgIcon="ic-off"
    >
    </mat-icon>
  </div>
  <ng-template #loadFav>
    <div class="as-heart-circle as-spinner-green">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  </ng-template>
  <a [routerLink]="product?.product_url">
    <div class="as-product-img as-pointer" (click)="onClickProduct()">
      <app-smart-label
        class="as-smart-offer-position"
        [product]="product"
        [options]="{
          clickable: false,
          showMore: false,
          showDiscount: false,
          isPDP: false
        }"
      ></app-smart-label>
      <img
        [defaultImage]="defaultImage"
        [lazyLoad]="productImage"
        onerror="this.src='src/assets/images/default-product.svg';"
        alt="Product image"
      />
    </div>
  </a>
  <a [routerLink]="product?.product_url">
    <div class="as-product-price as-pointer as-font" (click)="onClickProduct()">
      <mat-label
        *ngIf="
          product?.smart_offer !== '' && product?.offer_type === 1;
          else normalPrice
        "
        class="as-font as-font-bold as-font-error"
      >
        {{ product?.smart_offer | currency : '$'
        }}<span class="as-font-normal as-font-grey-88 as-font-14">{{
          product?.format === 'KG' ? '/Kg' : ''
        }}</span>
      </mat-label>
      <ng-template #normalPrice>
        <mat-label
          class="as-font-semibold as-font-blackish"
          [ngClass]="
            product.price === product.regular_price ? '' : 'as-font-error'
          "
        >
          {{ product.price | currency : '$'
          }}<span class="as-font-normal as-font-grey-88 as-font-14">{{
            product?.format === 'KG' ? '/Kg' : ''
          }}</span>
        </mat-label>
      </ng-template>
      <mat-label
        class="as-font-line-through as-font-blackish"
        *ngIf="product.price !== product.regular_price"
      >
        {{ product?.regular_price | currency : '$' }}
      </mat-label>
    </div>
  </a>
  <ng-container *ngIf="!productAdded; else quantityDetails">
    <a [routerLink]="product?.product_url">
      <div class="as-product-description as-pointer" (click)="onClickProduct()">
        <h2 class="as-font as-font-blackish">
          {{ product.description | titlecase | slice : 0 : 36
          }}{{ product.description.length > 36 ? '...' : '' }}
        </h2>
      </div>
    </a>
    <mat-label class="as-font-10 as-font-grey-7e">{{
      product.packing
    }}</mat-label>
    <button
      *ngIf="product?.stock > 0 && !addingProduct"
      mat-stroked-button
      [ngClass]="!displayProductQuantity ? 'mt-16' : 'mt-16'"
      class="as-product-add"
      color="accent"
      (click)="displayDetailsBeforeAdding()"
    >
      <mat-label>
        {{ 'GENERAL.add' | translate }}
      </mat-label>
    </button>
    <div
      class="as-spinner-green as-row as-justify-center"
      *ngIf="addingProduct"
    >
      <mat-spinner [diameter]="25"></mat-spinner>
    </div>
    <button
      *ngIf="
        (product?.stock === null ||
          product?.stock === undefined ||
          product?.stock <= 0) &&
        !addingProduct
      "
      mat-stroked-button
      [ngClass]="!displayProductQuantity ? 'mt-16' : 'mt-16'"
      class="as-product-unavailable"
      [disabled]="true"
    >
      <mat-label>
        {{ 'PURCHASE.off' | translate }}
      </mat-label>
    </button>
  </ng-container>
</mat-card>
<ng-template #quantityDetails>
  <div class="as-quantity-details">
    <div class="as-display-details" *ngIf="productAdded">
      <div class="as-quantity-container">
        <ng-container *ngIf="productTypeQuantity === 'pza'; else grams">
          <div class="as-quantity">
            <button mat-button color="accent" (click)="subtract()">
              <mat-icon svgIcon="ic-minus"></mat-icon>
            </button>
            <div class="input-value">
              <input
                mask="000000"
                suffix=" pz"
                (blur)="changePieces(productQuantity)"
                [(ngModel)]="productQuantity"
                type="text"
                readonly
              />
            </div>
            <button
              [disabled]="
                (productType === 'pza' && product?.stock <= productQuantity) ||
                (productType === 'pza-grammage' &&
                  this.product?.stock <= productQuantityGrams / 1000)
              "
              mat-button
              color="accent"
              #tooltip="matTooltip"
              matTooltip="Cantidad máxima"
              matTooltipPosition="above"
              [matTooltipDisabled]="
                !(
                  (productType === 'pza' &&
                    product?.stock <= productQuantity) ||
                  (productType === 'pza-grammage' &&
                    this.product?.stock <= productQuantityGrams / 1000)
                )
              "
              (click)="add()"
            >
              <mat-icon svgIcon="ic-plus"></mat-icon>
            </button>
          </div>
        </ng-container>
        <ng-template #grams>
          <div class="as-quantity">
            <button mat-button color="accent" (click)="subtract()">
              <mat-icon svgIcon="ic-minus"></mat-icon>
            </button>
            <div class="input-value">
              <input
                mask="000000"
                suffix=" gr"
                (blur)="changeGrams(productQuantityGrams)"
                [(ngModel)]="productQuantityGrams"
                type="text"
                readonly
              />
            </div>
            <button
              [disabled]="product?.stock <= productQuantityGrams / 1000"
              #tooltip="matTooltip"
              matTooltip="Cantidad máxima"
              matTooltipPosition="above"
              [matTooltipDisabled]="
                !(product?.stock <= productQuantityGrams / 1000)
              "
              mat-button
              color="accent"
              (click)="add()"
            >
              <mat-icon svgIcon="ic-plus"></mat-icon>
            </button>
          </div>
        </ng-template>
      </div>
      <div
        class="as-switch-quantity as-mb-1em"
        *ngIf="productType === 'pza-grammage'"
      >
        <button
          mat-flat-button
          class="as-type-select"
          [class.as-active]="productTypeQuantity === 'pza'"
          (click)="onSwitchTypeQuanity('pza')"
        >
          <mat-label class="as-font-10">
            {{ 'GENERAL.piece' | translate }}
          </mat-label>
        </button>
        <button
          mat-flat-button
          class="as-type-select"
          [class.as-active]="productTypeQuantity === 'grammage'"
          (click)="onSwitchTypeQuanity('grammage')"
        >
          <mat-label class="as-font-10">
            {{ 'GENERAL.grams' | translate }}
          </mat-label>
        </button>
      </div>

      <mat-select
        *ngIf="madurityList.length > 0"
        placeholder="{{ 'GENERAL.selectMadurity' | translate }}"
        [formControl]="madurity"
      >
        <mat-option value="{{ option }}" *ngFor="let option of madurityList">{{
          option
        }}</mat-option>
      </mat-select>

      <mat-select
        *ngIf="sliceList.length > 0"
        [formControl]="slice"
        placeholder="Rebanada"
      >
        <mat-option *ngFor="let item of sliceList" [value]="item">
          {{ item }}</mat-option
        >
      </mat-select>
      <button
        *ngIf="!addingProduct"
        [disabled]="
          ((madurityList.length > 0 || sliceList.length > 0) &&
            !madurity.value &&
            !slice.value) ||
          (productTypeQuantity === 'pza' &&
            productType === 'pza' &&
            product?.stock < productQuantity) ||
          (productTypeQuantity === 'pza' &&
            productType === 'pza-grammage' &&
            product?.stock < productQuantity * product?.weight) ||
          (productTypeQuantity !== 'pza' &&
            product?.stock < productQuantityGrams / 1000)
        "
        mat-stroked-button
        class="as-product-add-details"
        color="accent"
        (click)="onAddingToCart()"
      >
        <mat-label>
          {{
            !productAdded
              ? ('GENERAL.add' | translate)
              : ('GENERAL.update' | translate)
          }}
        </mat-label>
      </button>
      <div class="as-spinner-green" *ngIf="addingProduct">
        <mat-spinner [diameter]="25"></mat-spinner>
      </div>
    </div>
  </div>
</ng-template>
